import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import useAuth from './useAuth';
import { useParams } from 'react-router-dom';
import logo from './vdc_logo.png';
import 'react-toastify/dist/ReactToastify.css'; // Import default CSS for Toastify
import './CustomToastStyles.css'; // Import custom styles
import Header from './Header.js';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import pdficon from "./pdf.png";
import icon1 from "./picture.png";
import './AddSettlement.css';
//import { BASE_URL } from "./Constants.js";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Loader = () => (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
        </div>
        <p>Loading...</p>
    </div>
);

const EditSettlementForm = () => {
    const { id } = useParams();
    const [EmpCode, setEmpCode] = useState('');
    const [RptMgr, setRptMngr] = useState('');
    const [ReportManagerName, setReportManagerName] = useState('');
    const [rows1, setRows1] = useState([]);
    const [PerDiem, setPerDiem] = useState('');
    const [Amount, setAmount] = useState('');
    const [Purpose, setPurpose] = useState('');
    const [loading, setLoading] = useState(true);
    const [TotalLocal, setTotalLocal] = useState('');
    const [rows2, setRows2] = useState([]);
    const [localConveyanceTotals, setLocalConveyanceTotals] = useState({});
    const [items, setItems] = useState([]);
    const [errors, setErrors] = useState({
        account_status: '', // Initial errors can go here (empty or predefined)
    });
    const [documentsRows, setdocumentsRows] = useState([]);
    const [ReportManageName, setReportManageName] = useState('');
    const [AuditManageName, setAuditManageName] = useState('');

    const [error, setError] = useState('');
    useAuth();
    const [formData, setFormData] = useState({
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        password: '', // Do not display the password,
        travel_from_date: '', // Ensure this is initialized
        travel_to_date: '',   // Ensure this is initialized
        days: '',
        rpt_mgr_status: '',
        audit_status: '',
        audit_manager: '',
        advance_amount: '',
        manager_remarks: '',
        audit_approved_amount: '',
        audit_remarks: '',
        account_status: '',
        // finance_approved_amount: '',
        finance_remarks: '',
        utr: '',
        utr_date: '',
        accounts_manager: '',
        audit_approved_date: '',
        manager_approved_date: '',
        finance_approved_date: '',
        created_on: '',
        audit_flag: '',
        manager_approved_amount: '',
        focus_code: '',
        bank_acnum: '',
        bank_name: '',
        from_date: '',
        to_date:'',
        ifsc_code: ''
    });
    const [responseMessage, setResponseMessage] = useState('');
    const [isApproved, setIsApproved] = useState(false);
    const navigate = useNavigate();

    const validateFormData = () => {
        const { emp_code } = formData;
        if (!emp_code) {
            toast.error('All fields are required');
            return false;
        }
        return true;
    };

    useEffect(() => {
        const fetchCitiesData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                console.log("token1", token);
                const response = await fetch(`${API_BASE_URL}cities`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                console.log("get all cities data:", result);

                if (result.status) {
                    setItems(result.data);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            }
        };

        fetchCitiesData();
    }, []);

    const updateLocalConveyanceTotals = () => {
        const totals = {};
        transportRows.forEach((row) => {
            if (row.travelDate) {
                totals[row.travelDate] = (totals[row.travelDate] || 0) + (parseFloat(row.travelAmount) || 0);
            }
        });
        setLocalConveyanceTotals(totals);
    };
    const handleBackClick = () => {
        navigate("/finance_settlement_form");
    };
    const handleSubmit = async (e) => {

        e.preventDefault();

        let formIsValid = true;
        let newErrors = {};

        // If Reporting Manager Status is Pending, show error
        if (formData.account_status === 'Pending') {
            formIsValid = false;
            newErrors.account_status = 'Please approve the status before submitting.';
        }

        if (!formIsValid) {
            setErrors(newErrors); // Update errors state if form is invalid
            return;
        }

        if (!validateFormData()) return;
        const travelAdvance = (grandTotal() - parseFloat(Amount)) || 0;
        // if (parseFloat(formData.finance_approved_amount) != parseFloat(formData.manager_approved_amount)) {
        //     setError('Finance Approved Amount must be same as Manager Approved Amount.');
        //     return; // Prevent submission
        // }
        // const approvedAmount = parseFloat(formData.finance_approved_amount) || 0;



        const formDataToSubmit = new FormData();
        Object.keys(formData).forEach(key => {
            if (formData[key] !== null && formData[key] !== '') {
                formDataToSubmit.append(key, formData[key]);
            }
        });
        const dataToSubmit = {
            ...formData
        };
        try {
            const token = localStorage.getItem('authToken');
            console.log("check tokens", token);
            const response = await fetch(`${API_BASE_URL}updateSettlementForm/${id}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSubmit),
            });

            const result = await response.json();
            console.log("advanceformdata", result.data);
            if (result.status) {
                toast.success('Travel Advance Form successfully added');
                setFormData({
                    comp_name: '',
                    emp_code: ''
                });
                navigate('/finance_settlement_form');
            } else {
                toast.error(result.message || 'An error occurred while adding the travel advance form.');
            }
        } catch (error) {
            console.error('Fetch error:', error);
            toast.error('Failed to submit form');
        }
    };

    const generatePDF = () => {
        const doc = new jsPDF();
        // const logo = './vdc_logo.png';  // Assuming you have the logo as a file or base64 string
        // const fromCityName = items.find(city => city.id === row.from_city)?.city_name || '';

        // Outside the tbody loop: Compute fromCityName for each row
        const firstFromCityName = items.find(city => city.id === rows1[0]?.from_city)?.city_name || '';
        const firstToCityName = items.find(city => city.id === rows1[0]?.to_city)?.city_name || '';
        const dates = rows1.map(row => row.date).join(', ');
        const travelType = rows1.map(row => row.travelType).join(', ');


        // Add logo to the top left corner of the PDF (10, 10) and resize to fit
        doc.addImage(logo, 'PNG', 5, 10, 15, 15);  // X, Y, Width, Height

        // Title - Centered and Bold
        doc.setFontSize(22);
        doc.setFont('helvetica', 'bold');
        doc.text("Tour/Travel Settlement Finance Approval Form", 105, 20, null, null, 'center');

        // Line separator (draw a horizontal line below the title)
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.5);
        doc.line(10, 25, 200, 25); // Horizontal line below title

        // Header Section (Company Info)
        doc.setFontSize(12);
        doc.setFont('helvetica', 'normal');
        doc.text(`Emp Name: ${formData.comp_name}`, 10, 35);
        doc.text(`Employee No: ${formData.emp_code}`, 105, 35); // Second column starting at X=105

        // Row 2: Department and Grade
        doc.text(`Department: ${formData.dept_name}`, 10, 45);
        doc.text(`Grade: ${formData.grade}`, 90, 45); // Second column starting at X=105
        doc.text(`Location: ${formData.location_name}`, 125, 45);
        // Row 3: Report Manager and Created On
        doc.text(`Report Manager: ${formData.report_mngr}`, 10, 55);
        doc.text(`Created On: ${formData.created_on}`, 105, 55); //



        // Table for Detailed Form Data
        doc.autoTable({
            startY: 60, // Table starting position
            head: [['Field', 'Value']],
            body: [
                ['Purpose', formData.settlement_purpose],

                // ['Travel Advance', formData.travel_advance],

                ['Days', formData.days],
                // ['City', formData.city],


                ['From City', firstFromCityName],
                ['To City', firstToCityName],
                ['Front Date', formData.from_date],
                ['To Date', formData.to_date],
                ['Travel Type', travelType],
                ['Manager Approved Amount', grandTotal()],
                ['Audit Approved Amount', formData.audit_approved_amount],
                ['Audit Status', formData.audit_status === 'Pending' ? '' : formData.audit_status],
                ['Account Status', formData.account_status === 'Pending' ? '' : formData.account_status],
                ['Manager Remarks', formData.manager_remarks],
                // ['Accounts Approved Amount', formData.finance_approved_amount],
                ['Accounts Remarks', formData.finance_remarks],

                ['Manager Approved Date', formData.manager_approved_date],
                ['Audit Approved Date', formData.audit_approved_date],
                ['Accounts Manager', formData.accounts_manager],
                ['Trans Code', formData.trans_code],
                ['UTR', formData.utr],
                ['UTR Date', formData.utr_date],
                ['Focus Code', formData.focus_code],

                ['Bank Account No.', formData.bank_acnum],
                ['Bank Name', formData.bank_name],
                ['IFSC Code', formData.ifsc_code],
            ],
            theme: 'grid',
            headStyles: {
                fillColor: [0, 104, 116],           
                textColor: [255, 255, 255],
                fontSize: 12,
                font: 'helvetica',
            },
            bodyStyles: {
                fontSize: 10,
                font: 'helvetica',
            },
            margin: { top: 100, left: 10, right: 10 },
            styles: {
                halign: 'center',
                valign: 'middle',
            },
        });

        // Get the current position after the table
        let yPosition = doc.lastAutoTable.finalY + 10;

        // Section for "Prepared by"
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text("Prepared by:", 10, yPosition);
        doc.setFont('helvetica', 'normal');
        doc.text(`${formData.emp_code} (${formData.comp_name})`, 10, yPosition + 10);
        doc.text(`Date: ${formData.created_on}`, 10, yPosition + 20);

        // Section for "Approved by" (Side by side)
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text("Approved by:", 135, yPosition);  // Starting from X=105 for right alignment
        doc.setFont('helvetica', 'normal');
        doc.text(`${formData.report_mngr} (${ReportManageName})`, 105, yPosition + 10);
        doc.text(`Date: ${formData.manager_approved_date}`, 105, yPosition + 20);

        // Section for "Second Approved by" with empty date
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text("Audit Approved by:", 10, yPosition + 30);  // Starting from X=105 for right alignment
        doc.setFont('helvetica', 'normal');
        doc.text(`${formData.audit_manager} (${AuditManageName})`, 10, yPosition + 37); // Empty space for second approver's name
        doc.text(`Date: ${formData.audit_approved_date}`, 10, yPosition + 45); // Empty space for second approver's date

        // Section for "Approved by" (Side by side)
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text("Approved by:", 135, yPosition + 30);  // Starting from X=105 for right alignment
        doc.setFont('helvetica', 'normal');
        doc.text(`______________________`, 105, yPosition + 37);
        doc.text(`______________________`, 105, yPosition + 45);

        // Footer with page number
        const totalPages = doc.internal.getNumberOfPages();
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.text(`Page ${totalPages}`, 105, 290, null, null, "center");

        // Save the PDF
        doc.save("finance_approval_form.pdf");
    };









    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                console.log("token12", token);
                const response = await fetch(`${API_BASE_URL}getsettlement?id=${id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                console.log("Settlement data:", result);

                if (result.status) {
                    setTotalLocal(result.settlement.grandTotalLocal || '');
                    setEmpCode(result.settlement.emp_code || '');
                    setPerDiem(result.settlement.grandTotalPerDiem || '');
                    setReportManageName(result.reportManagerName.comp_name || '');
                    setAuditManageName(result.auditManagerName.comp_name || '');
                    const report_mngr = result.settlement.report_mngr || '';
                    const account_status = result.settlement.account_status || '';
                    setPurpose(result.settlement.purpose || '');
                    setAmount(result.settlement.travel_amount || '');
                    setFormData({
                        comp_name: result.settlement.comp_name || '',
                        focus_code: result.settlement.focus_code || '',
                        trans_code: result.settlement.trans_code || '',
                        guesthouse: result.settlement.guesthouse || '',
                        emp_code: result.settlement.emp_code || '',
                        dept_name: result.settlement.dept_name || '',
                        designation_name: result.settlement.designation_name || '',
                        settlement_purpose: result.settlement.settlement_purpose || '',
                        purpose: result.settlement.purpose || '',
                        mode_of_travel: result.settlement.mode_of_travel || '',
                        emp_remarks: result.settlement.emp_remarks || '',
                        advance_amount: result.settlement.advance_amount || '',
                        travel_amount: result.settlement.travel_amount || '',
                        days: result.settlement.days || '',
                        city: result.settlement.city || '',
                        travel_advance: result.settlement.travel_advance || '',
                        //  bank_details: result.data.bank_details || '',
                        grade: result.settlement.grade || '',
                        mobile: result.settlement.mobile || '',
                        rpt_mgr_status: result.settlement.rpt_mgr_status || '',
                        manager_remarks: result.settlement.manager_remarks || '',
                        report_mngr: report_mngr,
                        audit_status: result.settlement.audit_status || '',
                        already_taken_advance: result.settlement.already_taken_advance || '',
                        audit_manager: result.settlement.audit_manager || '',
                        audit_approved_amount: result.settlement.audit_approved_amount || '',
                        manager_approved_amount: result.settlement.manager_approved_amount || '',
                        audit_remarks: result.settlement.audit_remarks || '',
                        account_status: account_status || '',
                        // finance_approved_amount: result.settlement.finance_approved_amount || '',
                        finance_remarks: result.settlement.finance_remarks || '',
                        utr: result.settlement.utr || '',
                        utr_date: result.settlement.utr_date || '',
                        accounts_manager: result.settlement.accounts_manager || '',
                        audit_approved_date: result.settlement.audit_approved_date || '',
                        manager_approved_date: result.settlement.manager_approved_date || '',
                        finance_approved_date: result.settlement.finance_approved_date || '',
                        created_on: result.settlement.created_on || '',
                        bank_acnum: result.settlement.bank_acnum || '',
                        bank_name: result.settlement.bank_name || '',
                        ifsc_code: result.settlement.ifsc_code || '',
                        location_name: result.settlement.location_name || '',
                        audit_flag: 0,
                        from_date:result.settlement.from_date || '',
                        to_date:result.settlement.to_date || '',
                    });
                    setIsApproved(account_status === 'Approved');
                    //fetchReportingData(report_mngr);
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            }
        };

        fetchProfileData();
    }, []);



    useEffect(() => {
        const fetchSettlement1 = async () => {
            try {
                const token = localStorage.getItem('authToken');
                console.log("token1er", token);
                const response = await fetch(`${API_BASE_URL}getsettlement?travel_id1=${id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                console.log("settl;ement1", result);

                if (result.status) {
                    setRows1(result.settlement1);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchSettlement1();
    }, []);

    useEffect(() => {
        const fetchSettlement2 = async () => {

            try {
                const token = localStorage.getItem('authToken');
                console.log("token1a", token);

                const response = await fetch(`${API_BASE_URL}getsettlement?travel_id2=${id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                console.log("settlement2:", result);

                if (result.status) {
                    setRows2(result.settlement2);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            }
        };

        fetchSettlement2();
    }, []);

    useEffect(() => {
        const fetchSettlement4 = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}getsettlement?travel_id4=${id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                if (result.status) {
                    setdocumentsRows(result.settlement4);
                    // Initialize transportRows with data from the fetched settlement


                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                //setError('Failed to fetch data');
            }
        };

        fetchSettlement4();
    }, [id]);





    const [rows, setRows] = useState([
        { id: Date.now(), date: '', time: '', tourPlace: '', travelType: '', stayType: '', perDiem: '', local: '', misc: '', totalAmount: '' },

    ]);
    const handleChange = (id, event) => {
        // Check if event is defined
        if (!event || !event.target) {
            console.error("Event or event.target is undefined");
            return;
        }

        const { name, value } = event.target;

        // if (name === 'finance_approved_amount') {

        //     const travelAdvance = parseFloat(grandTotal() - parseFloat(Amount)) || 0;

        //     const approvedAmount = parseFloat(value) || 0;

            // if ((approvedAmount > 0) && (approvedAmount > travelAdvance) || (approvedAmount > formData.manager_approved_amount)) {
            //     console.log("check", value);
            //     setError('Finance Approved Amount must be less than or equal to Travel Amount Requisitioned.');
            // } else {
            //     setError(''); // Clear the error if both conditions are met
            // }
        // }

        // Update rows based on id
        const updatedRows = rows.map(row => {
            if (row.id === id) {
                const newRow = { ...row, [name]: value };
                newRow.totalAmount = (parseFloat(newRow.perDiem) || 0) + (parseFloat(newRow.local) || 0) + (parseFloat(newRow.misc) || 0);
                return newRow;
            }
            return row;
        });

        setRows(updatedRows);

        // Update formData if needed
        const newValue = name === 'utr' ? value.toUpperCase() : value;
        const newValue1 = name === 'focus_code' ? value.toUpperCase() : value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: newValue,
            [name]: newValue1,
        }));
        setRows((prevRows) =>
            prevRows.map((row) =>
                row.id === id ? { ...row, [name]: value } : row
            )
        );
    };

    const handleAddRow = () => {
        setRows([...rows, { id: Date.now(), date: '', time: '', tourPlace: '', travelType: '', stayType: '', perDiem: '', local: '', misc: '', totalAmount: '' }]);
    };

    const handleRemoveRow = (id) => {
        setRows(rows.filter(row => row.id !== id));
    };

    const calculateTotals = () => {
        return rows.reduce((acc, row) => {
            return {
                perDiem: acc.perDiem + (parseFloat(row.perDiem) || 0),
                local: acc.local + (parseFloat(row.local) || 0),
                misc: acc.misc + (parseFloat(row.misc) || 0),
                totalAmount: acc.totalAmount + (parseFloat(row.totalAmount) || 0)
            };
        }, { perDiem: 0, local: 0, misc: 0, totalAmount: 0 });
    };

    const totals = calculateTotals();


    const [transportRows, setTransportRows] = useState([{ id: 1, travelDate: '', origin: '', destination: '', travelAmount: '', transportMethod: '' }]);

    const handleAddTransportRow = () => {
        setTransportRows([...transportRows, { id: transportRows.length + 1, travelDate: '', origin: '', destination: '', travelAmount: '', transportMethod: '' }]);
        updateLocalConveyanceTotals();
    };

    const handleTransportChange = (index, e) => {
        const { name, value } = e.target;
        const newTransportRows = [...transportRows];
        newTransportRows[index] = { ...newTransportRows[index], [name]: value };
        setTransportRows(newTransportRows);
    };

    const handleRemoveTransportRow = (index) => {
        if (transportRows.length === 1) return; // Prevent removal if it's the only row
        const updatedRows = transportRows.filter((_, i) => i !== index).map((row, i) => ({ ...row, id: i + 1 }));
        setTransportRows(updatedRows);
        updateLocalConveyanceTotals();
    };



    const totalTravelAmount = transportRows.reduce((acc, row) => acc + (parseFloat(row.travelAmount) || 0), 0);
    const calculateLocalConveyanceByDate = (date) => {
        return transportRows
            .filter(row => row.travelDate === date)
            .reduce((acc, row) => acc + (parseFloat(row.travelAmount) || 0), 0);
    };

    const calculateGrandTotalLocalConveyance = () => {
        return transportRows.reduce((acc, row) => {
            return acc + (parseFloat(row.travelAmount) || 0);
        }, 0);
    };
    const calculateRowTotal = (row) => {
        const perDiem = parseFloat(row.perDiem) || 0;
        const local = calculateLocalConveyanceByDate(row.date);
        const misc = parseFloat(row.misc) || 0;
        return perDiem + local + misc;
    };
    const calculateGrandTotal = () => {
        return rows.reduce((acc, row) => {
            return acc + calculateRowTotal(row);
        }, 0);
    };
    const totalTransportAmount = rows2.reduce((acc, row) => acc + (parseFloat(row.travelAmount) || 0), 0);
    const grandTotal = () => {
        const totalHotelAmount = rows1.reduce((total, row) => total + (parseFloat(row.hotel_amount) || 0), 0);
        const totalTravelAmount = rows1.reduce((total, row) => total + (parseFloat(row.ticket_travel_amount) || 0), 0);
        const totalMisc = rows1.reduce((total, row) => total + (parseFloat(row.misc) || 0), 0);
        const totalPerDiem = rows1.reduce((total, row) => total + (parseFloat(row.perDiem) || 0), 0);

        return totalHotelAmount + totalTravelAmount + totalMisc + totalPerDiem + totalTransportAmount;
    };
    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">

                <Header />
                <Sidebar />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h4 className="m-0" style={{ fontSize: '20px' }}>Tour/Travel Exstation Finance Approval Form ({formData.trans_code})</h4>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <button
                                            type="button"
                                            className="btn btn-primary pull-right"
                                            onClick={generatePDF}
                                        >
                                            Generate PDF
                                        </button>
                                        <li className="breadcrumb-item" style={{ fontSize: '12px' }}><a href="#">Home</a></li>
                                        <li className="breadcrumb-item active" style={{ fontSize: '12px' }}>Tour/Travel Exstation Finance Approval Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader /> // Show loader if loading is true
                    ) : (
                        <>
                            <section className="col-lg-12">
                                <div className="card" style={{ borderTop: '3px solid #00c0ef' }}>
                                    <div className="box box-info">


                                        <div className="card-body">
                                            <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                                                <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                    <div className="box-body">
                                                        <div className="row">

                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Employee No
                                                                        <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="emp_code"
                                                                        id="name"
                                                                        value={formData.emp_code}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        placeholder="Employee No/Consultant"
                                                                        readonly="true"

                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Name <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="comp_name"
                                                                        id="name"
                                                                        value={formData.comp_name}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        placeholder="Name"
                                                                        readonly="true"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Employee Band<span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="grade"
                                                                        id="name"
                                                                        value={formData.grade}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        placeholder="Employee Band as per Category"
                                                                        readonly="true"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Department<span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="dept_name"
                                                                        id="name"
                                                                        value={formData.dept_name}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        placeholder="Department&Designation"
                                                                        readonly="true"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Designation <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="designation_name"
                                                                        id="name"
                                                                        value={formData.designation_name}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        placeholder="Department&Designation"
                                                                        readonly="true"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Mobile No
                                                                        <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="mobile"
                                                                        id="name"
                                                                        value={formData.mobile}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        placeholder="Days of travel"
                                                                        readonly="true"
                                                                    />
                                                                </div>
                                                            </div>



                                                        </div>
                                                        <div className="row">

                                                            <div className="col-md-1">
                                                                <div className="form-group">
                                                                    <label htmlFor="days">No of Days
                                                                        <span style={{ color: 'red' }}>*</span>
                                                                    </label>
                                                                    <input
                                                                        type="number"
                                                                        name="days"
                                                                        id="days"
                                                                        value={formData.days}
                                                                        onChange={(e) => handleChange('days', e)}
                                                                        className="form-control input-font"
                                                                        placeholder="1,1.5,2,2.5, etc"
                                                                        required
                                                                        readonly="true"


                                                                    />
                                                                </div>
                                                            </div>




                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="travelAdvance">Has advance settled <span style={{ color: 'red' }}>*</span></label>
                                                                    <select
                                                                        name="travel_advance"
                                                                        id="travelAdvance"
                                                                        value={formData.travel_advance}
                                                                        onChange={(e) => handleChange('travel_advance', e)}
                                                                        className="form-control input-font"
                                                                        readonly="true"
                                                                    >

                                                                        <option value="">Select</option>
                                                                        <option value="yes">Yes</option>
                                                                        <option value="no">No</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            {Purpose && (<>
                                                                {/* <div className="col-md-2">
                                                                    <div className="form-group">
                                                                        <label htmlFor="travelAmount">Travel Advance Amount <span style={{ color: 'red' }}>*</span></label>
                                                                        <input
                                                                            type="number"
                                                                            name="travel_amount"
                                                                            id="travelAmount"
                                                                            value={Amount}
                                                                            onChange={(e) => handleChange('travel_amount', e)} // Handle change for travel amount
                                                                            className="form-control input-font"
                                                                            required
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div> */}
                                                            </>)}

                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="settlement_purpose">Settlement Purpose <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="settlement_purpose"
                                                                        id="settlement_purpose"
                                                                        value={formData.settlement_purpose}
                                                                        onChange={(e) => handleChange('settlement_purpose', e)} // Handle change for settlement purpose
                                                                        className="form-control input-font"
                                                                        required
                                                                        readOnly
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <div className="form-group">
                                                                    <label style={{ fontSize: '12px' }} htmlFor="guesthouse">Select City Guest-House
                                                                        <span style={{ color: 'red' }}>*</span>
                                                                    </label>
                                                                    <select
                                                                        required
                                                                        name="guesthouse"
                                                                        id="guesthouse"
                                                                        value={formData.guesthouse}
                                                                        // onChange={handleGuesthouseChange}
                                                                        className="form-control input-font"
                                                                        disabled
                                                                    >
                                                                        <option value="">Select a Guest-House</option>
                                                                        <option value="Hyderabad">Hyderabad</option>
                                                                        <option value="Vishakapatnam">Vishakapatnam</option>
                                                                        <option value="Rajuhmundry">Rajuhmundry</option>
                                                                        <option value="Gurgaon">Gurgaon</option>
                                                                        <option value="Gulbarga">Gulbarga</option>
                                                                        <option value="no">No</option>
                                                                    </select>
                                                                </div>
                                                            </div>



                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Reporting Manager
                                                                        <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="mobile"
                                                                        id="name"
                                                                        value={formData.report_mngr}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        placeholder="Days of travel"
                                                                        readonly="true"
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Location
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="report_mngr"
                                                                        id="name"
                                                                        value={formData.location_name}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"

                                                                        readonly="true"
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="bank_acnum">Bank Ac Num
                                                                        <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="bank_acnum"
                                                                        id="bank_acnum"
                                                                        value={formData.bank_acnum}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"

                                                                        readonly="true"
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="bank_name">Bank Name
                                                                        <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="bank_name"
                                                                        id="bank_name"
                                                                        value={formData.bank_name}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"

                                                                        readonly="true"
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="ifsc_code">IFSC Code
                                                                        <span style={{ color: 'red' }}>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        name="ifsc_code"
                                                                        id="ifsc_code"
                                                                        value={formData.ifsc_code}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"

                                                                        readonly="true"
                                                                    />
                                                                </div>
                                                            </div>
                                                            


                                                        </div>




                                                    </div>
                                                    <div className="expense-table-container">

                                                        <table className="expense-table">
                                                            <thead>
                                                                <tr>
                                                                    <td colSpan="9"></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr className="header-row">
                                                                    <th>Date</th>
                                                                    <th>Time</th>
                                                                    <th>Travel Type</th>
                                                                    <th>From Place</th>
                                                                    <th>To Place</th>
                                                                   


                                                                    <th>Per Diem Allow</th>

                                                                    {/* <th>Local Conveyance</th> */}
                                                                    <th>Misc Exp</th>
                                                                    <th>Total Rs.</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {rows1.map((row, index) => {

                                                                    const total = (
                                                                        (parseFloat(row.hotel_amount) || 0) +
                                                                        (parseFloat(row.ticket_travel_amount) || 0) +
                                                                        (parseFloat(row.perDiem) || 0) + (parseFloat(PerDiem)) +
                                                                        (index === 0 ? parseFloat(TotalLocal) : 0) + // Include Local Conveyance only for the first row
                                                                        (parseFloat(row.misc) || 0)
                                                                    );
                                                                    return (
                                                                        <tr key={row.id}>
                                                                            <td data-label="Date">
                                                                                <input type="date" name="date" readonly="true" value={row.date} onChange={(e) => handleChange(row.id, e)} className="form-control input-font" />
                                                                            </td>
                                                                            <td data-label="Time">
                                                                                <input type="time" name="time" readonly="true" value={row.time} onChange={(e) => handleChange(row.id, e)} className="form-control input-font" />
                                                                            </td>
                                                                            <td data-label="Travel Type">
                                                                                <select name="travelType" disabled value={row.travelType} onChange={(e) => handleChange(row.id, e)} className="form-control input-font" required>
                                                                                    <option value="">Select Travel Type</option>

                                                                                    {(formData.grade && ['E', 'F'].includes(formData.grade[0])) ? (
                                                                        <>
                                                                            <option value='Company_Car'>Company Car</option>
                                                                            <option value='Own'>Own</option>
                                                                            {/* <option value="Store_Vehicle">Store Vehicle</option> */}
                                                                        </>

                                                                    ) : (
                                                                        <>
                                                                            <option value='Company_Car'>Company Car</option>
                                                                            <option value='Own'>Own</option>
                                                                            {/* <option value="Store_Vehicle">Store Vehicle</option> */}
                                                                        </>
                                                                    )}
                                                                                </select>
                                                                            </td>
                                                                            <td data-label="From Place">
                                                                                <select disabled name="from_city" value={row.from_city} onChange={(e) => handleChange(row.id, e)} className="form-control input-font">
                                                                                    <option value="">Select a Tour Place</option>
                                                                                    {items.map(city => (
                                                                                        <option key={city.id} value={city.id}>
                                                                                            {city.city_name}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </td>
                                                                            <td data-label="To Place">
                                                                                <select disabled name="to_city" value={row.to_city} onChange={(e) => handleChange(row.id, e)} className="form-control input-font">
                                                                                    <option value="">Select a Tour Place</option>
                                                                                    {items.map(city => (
                                                                                        <option key={city.id} value={city.id}>
                                                                                            {city.city_name}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </td>
                                                                           
                                                                            <td data-label="Per Diem Allow">
                                                                                <input
                                                                                    type="number"
                                                                                    name="perDiem"
                                                                                    value={row.perDiem}
                                                                                    onChange={(e) => handleChange(row.id, e)}
                                                                                    className="form-control input-font"
                                                                                    required
                                                                                    disabled
                                                                                />
                                                                            </td>

                                                                            {/* <td data-label="Local Conveyance">
                                                                                <input
                                                                                    type="number"
                                                                                    name="local"
                                                                                    value={index === 0 ? parseFloat(totalTransportAmount).toFixed(2) : 0} // Set TotalLocal in first cell
                                                                                    onChange={(e) => handleChange(row.id, e)}
                                                                                    className="form-control input-font"
                                                                                    disabled // Disable other cells
                                                                                    readOnly
                                                                                />
                                                                            </td> */}
                                                                            <td data-label="Misc Exp">
                                                                                <input type="text" name="misc" readonly="true" value={row.misc} onChange={(e) => handleChange(row.id, e)} className="form-control input-font" placeholder="Misc Exp" />
                                                                            </td>
                                                                            <td data-label="Total Rs.">
                                                                                <input
                                                                                    type="number"

                                                                                    value={
                                                                                        parseFloat(
                                                                                            (parseFloat(row.perDiem)) +
                                                                                            parseFloat(row.hotel_amount) +
                                                                                            parseFloat(row.ticket_travel_amount) +
                                                                                            parseFloat(row.misc) +
                                                                                            (index === 0 ? parseFloat(totalTransportAmount) : 0)
                                                                                        )
                                                                                    }
                                                                                    className="form-control input-font"
                                                                                    readOnly
                                                                                />
                                                                            </td>
                                                                            <td data-label="Actions">

                                                                            </td>
                                                                        </tr>);
                                                                })}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th colSpan="7" style={{ textAlign: 'right' }}>Grand Total</th>
                                                                    <th style={{ textAlign: 'center' }}>{parseFloat(grandTotal().toFixed(2))}</th>
                                                                    <th></th>
                                                                </tr>

                                                                
                                                                <tr>
                                                                    <th colSpan="7" style={{ textAlign: 'right',color: 'green' }}>Total</th>
                                                                    <th style={{ textAlign: 'center',color: 'green' }}>{parseFloat(grandTotal().toFixed(2))}</th>
                                                                    <th></th>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>


                                                </fieldset>
                                                <br />
                                                
                                                <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                    <center><span className="btn btn-primary" style={{ fontSize: '12px' }}>Additional Documents</span></center>
                                                    <div className="document-table-container" style={{ marginBottom: '20px', textAlign: 'right' }}>

                                                        <table className="document-table" style={{ marginTop: '10px' }}>
                                                            <thead>
                                                                <tr>

                                                                    <th style={{ textAlign: 'center' }}>Click to Preview</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {/* Loop through documentsRows and display each document's image */}
                                                                {documentsRows.length > 0 ? (
                                                                    <tr>
                                                                        <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                                                {documentsRows.map((document) => (
                                                                                    <div key={document.id} style={{ margin: '10px' }}>
                                                                                        <a href={document.additional_doc} target="_blank" rel="noopener noreferrer" className="position-relative">
                                                                                            {document.additional_doc.toLowerCase().endsWith('.pdf') ? (
                                                                                                // If the document is a PDF, show the PDF icon
                                                                                                <img
                                                                                                    src={pdficon}// Replace with the actual path to your PDF icon
                                                                                                    alt={`PDF Document ${document.id}`}
                                                                                                    style={{
                                                                                                        width: '79px',
                                                                                                        height: '100px',
                                                                                                        objectFit: 'cover',
                                                                                                        margin: '5px',
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                // Otherwise, show the image
                                                                                                <img
                                                                                                    src={document.additional_doc}
                                                                                                    alt={`Document ${document.id}`}
                                                                                                    style={{
                                                                                                        width: '100px',
                                                                                                        height: '100px',
                                                                                                        objectFit: 'cover',
                                                                                                        margin: '5px',
                                                                                                    }}
                                                                                                />
                                                                                            )}
                                                                                        </a>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                            {error ? error : 'No documents available.'}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </fieldset>
                                                {formData.emp_remarks && (<>
                                                    <div style={{ marginBottom: '20px' }}>
                                                        <label htmlFor="emp_remarks" style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
                                                            Miscellaneous Remarks
                                                        </label>
                                                        <textarea
                                                            name="emp_remarks"
                                                            id="emp_remarks"
                                                            rows="3"
                                                            className="form-control"
                                                            placeholder="Enter remarks here..."
                                                            style={{
                                                                width: '100%',
                                                                padding: '10px',
                                                                fontSize: '14px',
                                                                border: '1px solid #ccc',
                                                                borderRadius: '4px',
                                                                resize: 'vertical',
                                                            }}
                                                            onChange={handleChange}
                                                            value={formData.emp_remarks}
                                                            disabled
                                                        />
                                                    </div>
                                                </>)}
                                                <div class="row"><div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="rpt_mgr_status">Reporting Manager Status
                                                            {/* <span style={{ color: 'red' }}>*</span> */}
                                                        </label>
                                                        <select
                                                            name="rpt_mgr_status"
                                                            id="rpt_mgr_status"
                                                            value={formData.rpt_mgr_status}
                                                            onChange={(e) => handleChange('rpt_mgr_status', e)}
                                                            readonly="true"
                                                            className="form-control input-font"
                                                            disabled
                                                        >

                                                            <option value="Pending">Pending</option>
                                                            <option value="Approved">Approved</option>
                                                            <option value="Rejected">Rejected</option>
                                                        </select>
                                                    </div>
                                                </div><div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">Reporting Manager Approved Amount
                                                                {/* <span style={{ color: 'red' }}>*</span> */}
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="manager_approved_amount"
                                                                id="name"
                                                                //value={formData.manager_approved_amount}
                                                                value={grandTotal() !== '' ? Math.floor(grandTotal()) : ''}
                                                                readonly="true"
                                                                onChange={(e) => handleChange('manager_approved_amount', e)}
                                                                className="form-control input-font"
                                                                placeholder="Advance Approved Amount"
                                                                min="1"
                                                                step="1"
                                                                disabled

                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="manager_remarks">Reporting Manager Remarks
                                                                {/* <span style={{ color: 'red' }}>*</span> */}
                                                            </label>

                                                            <textarea
                                                                id="manager_remarks"
                                                                name="manager_remarks"
                                                                value={formData.manager_remarks}
                                                                onChange={(e) => handleChange('manager_remarks', e)}
                                                                className="form-control"
                                                                disabled
                                                                rows='1'
                                                                readonly="true"
                                                            ></textarea>
                                                        </div>
                                                    </div></div>
                                                <div class="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="audit_status">Audit Status
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <select
                                                                name="audit_status"
                                                                id="audit_status"
                                                                value={formData.audit_status}
                                                                onChange={(e) => handleChange('audit_status', e)}
                                                                readonly="true"
                                                                className="form-control input-font"
                                                                disabled

                                                            >

                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>
                                                                <option value="Rejected">Rejected</option>
                                                            </select>
                                                        </div>
                                                    </div><div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">Audit Approved Amount
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="audit_approved_amount"
                                                                id="name"
                                                                //value={formData.audit_approved_amount}
                                                                value={formData.audit_approved_amount !== '' ? Math.floor(formData.audit_approved_amount) : ''}
                                                                readonly="true"
                                                                onChange={(e) => handleChange('audit_approved_amount', e)}
                                                                className="form-control input-font"
                                                                placeholder="Advance Approved Amount"
                                                                min="1"
                                                                step="1"
                                                                disabled


                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="audit_remarks">Audit Remarks
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>

                                                            <textarea
                                                                id="audit_remarks"
                                                                name="audit_remarks"
                                                                required
                                                                rows='1'
                                                                value={formData.audit_remarks}
                                                                onChange={(e) => handleChange('audit_remarks', e)}
                                                                className="form-control"
                                                                placeholder="audit remarks"
                                                                readonly="true"
                                                                disabled
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="account_status">Finance Status
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <select
                                                                name="account_status"
                                                                id="account_status"
                                                                required
                                                                value={formData.account_status}
                                                                onChange={(e) => handleChange('account_status', e)}

                                                                className="form-control input-font custom-select"

                                                            >

                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>
                                                                <option value="Rejected">Rejected</option>
                                                            </select>
                                                            {errors.account_status && (
                                                                <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                                    {errors.account_status}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">Finance Approved Amount
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                name="finance_approved_amount"
                                                                id="name"
                                                                value={formData.finance_approved_amount !== '' ? Math.floor(formData.finance_approved_amount) : ''}
                                                                min="1"
                                                                step="1"

                                                                onChange={(e) => handleChange('finance_approved_amount', e)}
                                                                className="form-control input-font"
                                                                required
                                                            />
                                                        </div>
                                                        {error && <p style={{ color: 'red' }}>{error}</p>} 
                                                    </div> */}
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="finance_remarks">Finance Remarks
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>

                                                            <textarea
                                                                id="finance_remarks"
                                                                name="finance_remarks"
                                                                rows='1'
                                                                value={formData.finance_remarks}
                                                                onChange={(e) => handleChange('finance_remarks', e)}
                                                                className="form-control"
                                                                required

                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">UTR

                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="utr"
                                                                id="name"
                                                                value={formData.utr}

                                                                onChange={(e) => handleChange('utr', e)}
                                                                className="form-control input-font"
                                                                placeholder="utr"


                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">date

                                                            </label>
                                                            <input
                                                                type="date"
                                                                name="utr_date"
                                                                id="utr_date"
                                                                value={formData.utr_date}

                                                                onChange={(e) => handleChange('utr_date', e)}
                                                                className="form-control input-font"
                                                                placeholder="utr date"


                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="focus_code">Focus Code

                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="focus_code"
                                                                id="focus_code"
                                                                value={formData.focus_code}

                                                                onChange={(e) => handleChange('focus_code', e)}
                                                                className="form-control input-font"
                                                                placeholder="Focus code"


                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-12 row" style={{ width: '100%' }}>
                                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                                        <b>Prepared by </b>
                                                        <p> {formData.emp_code} ({formData.comp_name})<br /> Date
                                                            : {formData.created_on}
                                                        </p>
                                                    </div>
                                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                                        {formData.rpt_mgr_status === 'Approved' && (
                                                            <>
                                                                <b> Approved by</b>
                                                                <p> {formData.report_mngr} ({ReportManageName})<br /> Date
                                                                    : {formData.manager_approved_date}
                                                                </p>
                                                            </>
                                                        )}
                                                    </div>
                                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                                        {formData.audit_status === 'Approved' && (
                                                            <>
                                                                <b> Verified by Audit Team</b>
                                                                <p>                         <span>
                                                                    {formData.audit_manager} ({AuditManageName})   <br /> Date
                                                                    : {formData.audit_approved_date}
                                                                </span>
                                                                </p>
                                                            </>
                                                        )}
                                                    </div>



                                                </div>



                                                <div className="box-footer">
                                                    <br />
                                                    <center><button type="submit" className="btn btn-success pull-right">Submit</button>
                                                        <button
                                                            className="btn btn-secondary  ml-3"
                                                            onClick={handleBackClick} // Handle redirect
                                                        >
                                                            Cancel
                                                        </button></center>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </>
                    )}
                </div>

                <Footer />

                <aside className="control-sidebar control-sidebar-dark">
                </aside>

            </div>

            {/* Toast Container */}
            <ToastContainer />
        </div>
    );
};

export default EditSettlementForm;
